export default __webpack_public_path__ + "static/media/san-rafael-12.3f0239e0.jpg";